import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Select,
  MenuItem,
} from "@mui/material";
import React from "react";

// TABLE CHE COMPONE CON SELECT TUTTO IL FORM
export const renderTable = (
  errors,
  user,
  sections,
  firstHeader,
  autoLabel,
  partnerLabel,
  onChangeEValuo,
  eValuo,
  formatKey,
  isSecond = false
) => {
  //  ruolo
  const isProfessionista = user.role === "collaborator";
  const isPartner = user.role === "partner";

  const phaseEvaluo = Number(eValuo?.phase);

  return (
    <TableContainer
      component={Paper}
      sx={{
        marginTop: isSecond ? "50px" : 3,
        overflowX: "auto",
        borderRadius: 0,
        boxShadow: "none",
      }}
    >
      <Table
        size="small"
        sx={{
          tableLayout: "fixed",
          width: "100%",
          minWidth: "600px",
          tableLayout: {
            xs: "auto",
            md: "fixed",
          },
        }}
      >
        <TableHead className="bg-blue-dark">
          <TableRow>
            <TableCell
              sx={{
                padding: "16px 16px",
                width: "40%",
                minWidth: "300px",
                maxWidth: "300px",
              }}
            >
              <div
                style={{
                  width: "100%",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  color: "#fff",
                }}
              >
                {firstHeader}
              </div>
            </TableCell>

            <TableCell
              sx={{
                padding: "16px 16px",
                width: "20%",
                textAlign: "center",
              }}
            >
              <Typography className="color-light">{autoLabel}</Typography>
            </TableCell>

            <TableCell
              sx={{
                padding: "16px 16px",
                width: "20%",
                textAlign: "center",
              }}
            >
              <Typography className="color-light">{partnerLabel}</Typography>
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {sections.map((section, index) => (
            <React.Fragment key={section.title + index}>
              <TableRow
                sx={{
                  backgroundColor: section.isMainHeader ? "#1b2838" : "#a2bdcb",
                }}
              >
                <TableCell
                  colSpan={3}
                  sx={{
                    color: section.isMainHeader ? "#fff" : "#000",
                    fontWeight: section.isMainHeader ? 600 : 400,
                  }}
                >
                  <Typography className="color-blue-dark">
                    {section.title}
                  </Typography>
                </TableCell>
              </TableRow>

              {section.rows.map((row, i) => (
                <TableRow key={row + i}>
                  {/* Colonna titolo */}
                  <TableCell
                    sx={{
                      width: "40%",
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                    }}
                  >
                    <Typography className="color-blue-dark">{row}</Typography>
                  </TableCell>

                  {/* Colonna PROFESSIONISTA */}
                  <TableCell
                    sx={{
                      width: "30%",
                      textAlign: "center",
                      padding: 0,
                      backgroundColor: isProfessionista
                        ? errors?.includes(formatKey(row + "_collaborator"))
                          ? "#ffcccc"
                          : phaseEvaluo === 0
                          ? "#fae63436"
                          : "#fff"
                        : "#fff",
                    }}
                  >
                    {isPartner && phaseEvaluo <= 1 ? (
                      <Typography sx={{ py: 1.2 }}>-</Typography>
                    ) : isProfessionista && phaseEvaluo === 0 ? (
                      <Select
                        displayEmpty
                        variant="standard"
                        disableUnderline
                        fullWidth
                        value={
                          eValuo?.data_collaborator?.[
                            formatKey(row + "_collaborator")
                          ] || ""
                        }
                        onChange={(e) =>
                          onChangeEValuo(row + "_collaborator", e.target.value)
                        }
                        sx={{
                          height: "100%",
                          textAlign: "center",
                          backgroundColor: "transparent",
                          "& .MuiSelect-select": {
                            py: 1.2,
                            textAlign: "center",
                          },
                          "& .MuiSvgIcon-root": { color: "#1b2838" },
                        }}
                      >
                        <MenuItem value="">
                          <span style={{ color: "#1b2838" }}>Seleziona</span>
                        </MenuItem>
                        {["N.A.", "1", "2", "3", "4", "5"].map((v) => (
                          <MenuItem key={v} value={v}>
                            <Typography className="color-blue-dark">
                              {v}
                            </Typography>
                          </MenuItem>
                        ))}
                      </Select>
                    ) : (
                      <Typography sx={{ py: 1.2 }}>
                        {eValuo?.data_collaborator?.[
                          formatKey(row + "_collaborator")
                        ] || "-"}
                      </Typography>
                    )}
                  </TableCell>

                  {/* Colonna PARTNER */}
                  <TableCell
                    sx={{
                      width: "30%",
                      textAlign: "center",
                      padding: 0,
                      backgroundColor: isPartner
                        ? errors?.includes(formatKey(row + "_partner"))
                          ? "#ffcccc"
                          : phaseEvaluo !== 1
                          ? "#fff"
                          : "#fae63436"
                        : "#fff",
                    }}
                  >
                    {isProfessionista || phaseEvaluo !== 1 ? (
                      <Typography sx={{ py: 1.2 }}>
                        {eValuo?.data_partner?.[formatKey(row + "_partner")] ||
                          "-"}
                      </Typography>
                    ) : (
                      <Select
                        displayEmpty
                        variant="standard"
                        disableUnderline
                        fullWidth
                        value={
                          eValuo?.data_partner?.[formatKey(row + "_partner")] ||
                          ""
                        }
                        onChange={(e) =>
                          onChangeEValuo(row + "_partner", e.target.value)
                        }
                        sx={{
                          height: "100%",
                          textAlign: "center",
                          backgroundColor: "transparent",
                          "& .MuiSelect-select": {
                            py: 1.2,
                            textAlign: "center",
                          },
                          "& .MuiSvgIcon-root": { color: "#9d9d9eff" },
                        }}
                      >
                        <MenuItem value="">
                          <span
                            style={{ color: isPartner ? "#1b2838" : "#abb0b6" }}
                          >
                            Seleziona
                          </span>
                        </MenuItem>
                        {["N.A.", "1", "2", "3", "4", "5"].map((v) => (
                          <MenuItem key={v} value={v}>
                            <Typography className="color-blue-dark">
                              {v}
                            </Typography>
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
